import NotFound from "pages/notFound";
import { CAMPAIGN as BASE } from "./route";

export const CAMPAIGN_NOT_FOUND = BASE.sub("/*", NotFound);
